//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import OperatorMap from './OperatorMap.vue'
  import ArticleListItem from './ArticleListItem.vue'
  import FavouritesShare from './FavouritesShare.vue'
  import { EventBus } from './event-bus'
  import BtnFavourites from './ButtonFavourites.vue'
  import mixins from './utilities.js'

  export default {
    name: 'Favourites',
    props: {},
    mixins: [mixins],
    components: {
      OperatorMap,
      ArticleListItem,
      BtnFavourites,
      FavouritesShare,
    },
    data: function () {
      return {
        operators: [],
        operatorIds: '',
        operatorLength: 0,
        noResults: false,
        restParamsString: '',
        queryString: '',
        mapOperators: [],
        shareModalActive: false,
        isLoading: false,
        //bus: new Vue()
      }
    },
    mounted: function () {
        EventBus.$on('click:addtofavouritesInInfoWindow',(payload) => {
           this.removeFromFavourites(payload.id);
        })    
    },
    created: function () {
      
      if (window.favouritesData['ids']) {
        this.operatorIds = JSON.parse(window.favouritesData['ids'])
      } else if (localStorage.getItem('favourites_ids') !== null) {
        this.operatorIds = JSON.parse(localStorage.getItem('favourites_ids'))
      }

      this.getPostsRequest = this.makeAJAXRequest()

      window.onpopstate = function (event) {
        console.warn('location: ' + document.location + ', state: ' + JSON.stringify(event.state))
      }

      this.getPosts()
    },
    methods: {
      getPosts: function () {
        console.warn('GETTINGPOSTS')
        var _this = this

        this.noResults = false
        this.queryString = '' // if there is no category specified, if will get all post regardless of what category
        this.isLoading = true;

        if (this.operatorIds !== '') {
          for (let i = 0; i < this.operatorIds.length; i++) {
            this.queryString += '&id[]=' + this.operatorIds[i]
          }
        }

        // console.warn(`query string = ${this.queryString}`)

        this.getPostsRequest(`${pageInfo.site_url}/wp-json/wisdom-favourites/v1/favourites?exclude_nocoords=0${_this.queryString}`, {})

          .then(function (response) {
            if (response) { // check incase request was previously cancelled is wont produce results
              console.warn(response)

              let newPosts = response.data

              newPosts.forEach(item => {
                if (item.operator_data.display_page === false) {
                  // non members don't have full pages ie a link (except if they have been allowed to display a page) 
                  item['fimg'] = false // they don't have custom images (incase there is already one set)
                  item['url'] = false
                }
              })

              _this.operators = newPosts // replace all old posts with new results

              _this.isLoading = false;

              // if(newPosts.length == 0)
              //   this.loadMessage = "No data found"; // for when there is actually no data
              // else
              //   this.loadMessage = ""
              //_this.isLoading = false;
              //_this.pagesTotal = response.headers["x-wp-totalpages"];

              //if(_this.isMapView)
//                            EventBus.$emit('update-operator-map')

              if (response.data.length < 1)
                _this.noResults = true
            }
          })

      },
      removeFromFavourites: function (postId) {
        this.operators = this.operators.filter(function (operator) {
          return operator.id !== postId
        })

        this.operatorIds = this.operators.map(operator => operator.id)

        localStorage.setItem('favourites_ids', JSON.stringify(this.operatorIds))

        if (this.operatorIds.length < 1)
          this.noResults = true
      },
       appClasses() {
        let cssClass=[];

        cssClass.push("article-list");

        if(this.isLoading)
            cssClass.push("is-loading");

        return cssClass;
      },
      favouritesBtnClicked: function(payload) {
        this.removeFromFavourites(payload.id)
      },
      updateShareModal: function (state) {
        this.shareModalActive = state
      },
    },
    computed: {
      filteredData () {
        return this.operators
      },
      operatorsWithMarkers () {
        return this.operators.filter( (item) => {
          if(item.operator_data.latitude)
            return true;
          }
        );
      },
      shareUrl () {
        let queryString = ''
        if (this.operatorIds !== '') {
          for (let i = 0; i < this.operatorIds.length; i++) {
            queryString += '&id[]=' + this.operatorIds[i]
          }
          return queryString
        }
        return false
      }
    }
  }





// WEBPACK FOOTER //
// ./scripts/vue/Favourites.vue